import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import AppNavigationUnifiedQuery from './__generated__/AppNavigationUnifiedQuery.graphql.ts';
export function preloadAppNavigation() {
	return waitForAllReturnWhenError([
		query({
			query: AppNavigationUnifiedQuery,
		}),
		preloadWebItemLocation({
			location: 'system.header/left',
		}),
	]);
}
